import {ShippingRuleModel} from './ShippingRule.model';
import {ShippingInformation, CarrierErrors} from '@wix/auto_sdk_ecom_current-cart';
import {getShippingRuleInfo} from './shippingRuleInfoImportedFromNodeGQL';
import {
  SelectedCarrierServiceOptionModel,
  SelectedCarrierServiceOptionWithPrivateFields,
} from './SelectedCarrierServiceOption.model';
import {ModelContext} from '../../types/app.types';
import {SPECS} from '../specs';

export class ShippingInfoModel {
  /**
   * @deprecated
   */
  public status: string;
  /**
   * @deprecated
   */
  public shippingRule: ShippingRuleModel;
  /**
   * @deprecated
   */
  public canShipToDestination: boolean;
  /**
   * @deprecated
   */
  public selectedCarrierServiceOptionCode: string;
  public selectedCarrierServiceOption: SelectedCarrierServiceOptionModel;

  constructor(params: ShippingInfoModel) {
    this.status = params.status;
    this.shippingRule = params.shippingRule;
    this.canShipToDestination = params.canShipToDestination;
    this.selectedCarrierServiceOptionCode = params.selectedCarrierServiceOptionCode;
    this.selectedCarrierServiceOption = params.selectedCarrierServiceOption;
  }

  public static fromSDK(shippingInfo: ShippingInformation, carrierErrors: CarrierErrors, modelContext: ModelContext) {
    if (modelContext.viewerContext.isExperimentEnabled(SPECS.UseDeliveryOptionsLibInCart)) {
      return new ShippingInfoModel({
        status: undefined,
        shippingRule: undefined,
        canShipToDestination: undefined,
        selectedCarrierServiceOptionCode: shippingInfo?.selectedCarrierServiceOption?.code,
        selectedCarrierServiceOption: SelectedCarrierServiceOptionModel.fromSDK(
          shippingInfo?.selectedCarrierServiceOption as SelectedCarrierServiceOptionWithPrivateFields
        ),
      });
    }
    const shippingRuleInfo = getShippingRuleInfo(
      shippingInfo,
      carrierErrors,
      modelContext.viewerContext.isExperimentEnabled(SPECS.FixPricesOnDeliveryMethodDropdown)
    );

    return new ShippingInfoModel({
      status: shippingRuleInfo?.status ?? /* istanbul ignore next */ undefined,
      shippingRule: shippingRuleInfo?.shippingRule
        ? ShippingRuleModel.fromGQL(shippingRuleInfo.shippingRule, modelContext)
        : undefined,
      canShipToDestination: shippingRuleInfo?.canShipToDestination ?? /* istanbul ignore next */ undefined,
      selectedCarrierServiceOptionCode: shippingInfo?.selectedCarrierServiceOption?.code,
      selectedCarrierServiceOption: undefined,
    });
  }
}
